import React, { useState, useEffect } from 'react';
import { CButton, CCard, CCardBody, CCol, CRow, CBadge, CLabel, CSelect, CFormGroup, CProgress, CProgressBar, CSpinner } from '@coreui/react';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './ProjectDetails.css';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ModalComments from 'src/reusable/modal-comment/ModalComments';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import useSubscriptionCheck from 'src/utils/useSubscriptionCheck';
import { useDialog } from 'src/utils/DialogContext';
import { getTwoWeeksFilter, getTwoWeeksData, saveWeekly } from 'src/request/Reports';
import { DownloadReportWeekly } from 'src/request/Projects';
import { findAllowedFeature } from 'src/utils/findAllowedFeature';
import { showError } from 'src/utils/swalError';
import { trackEvent, mixPanelEvents } from 'src/utils/mixpanel';

const TwoWeeks = (props) => {
  const features = useSelector((state) => state.ui.features);
  const [toggle, setToggle] = useState([]);
  const [weeklyReport, setWeeklyReport] = useState([]);
  const [date, setDate] = useState('');
  const [baseDate, setBaseDate] = useState('');
  const [weeks, setWeeks] = useState([]);
  const [projectId, setprojectId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloadableReportAllowed, setIsDownloadableReportAllowed] = useState(false);
  const [isModalCommentOpen, setIsModalCommentOpen] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const { openDialog, closeDialog } = useDialog();
  const { refreshSubscription, handleSubscriptionRequest, NoCreditsLeft } = useSubscriptionCheck();

  useEffect(() => {
    getWeeks(props.id);
    setprojectId(props.id);
  }, []);

  useEffect(() => {
    if (features.length > 0) {
      setIsDownloadableReportAllowed(findAllowedFeature(features, 5));
    }
  }, [features]);

  const getWeeks = (project_id) => {
    getTwoWeeksFilter(project_id).then((res) => {
      if (res.data.status == 200) {
        setWeeks(res.data.response);
        setDate(`${res.data.response[0].start_date} - ${res.data.response[0].end_date} `);
        setBaseDate(`${res.data.response[0].start_date} - ${res.data.response[0].end_date} `);
        getTwoWeeks(`${res.data.response[0].start_date} - ${res.data.response[0].end_date} `);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `${res.data.response}. Please adjust start date or duration in Overview tab.`,
        });
      }
    });
  };

  const getTwoWeeks = (value) => {
    setDate(value);
    let date = value.split(' - ');
    getTwoWeeksData(props.id, date[0], date[1]).then((res) => {
      if (res.status == 200) {
        setWeeklyReport(res?.data?.data ?? []);
        setHasChanges(false);
      }
    });
  };

  const openModalComment = (item) => {
    setReportData(item);
    setIsModalCommentOpen(true);
  };

  const closeModalComment = () => {
    setIsModalCommentOpen(false);
    setReportData([]);
  };

  const adjustDateFormat = (strDate) => {
    if (strDate) {
      let a = new Date(strDate);
      let sm = `${a.getMonth() + 1}`.padStart(2, 0);
      let sd = `${a.getDate()}`.padStart(2, 0);
      let sy = a.getFullYear();
      let formatted = `${sm}/${sd}/${sy}`;
      return formatted;
    }
    return '';
  };

  const saveChanges = () => {
    let arr = [...weeklyReport];
    let newArr = [];

    for (let i = 0; i < arr.length; i++) {
      let newItem = [];
      arr[i].date_range = date;
      arr[i].save_type = 'TW';

      for (let j = 0; j < arr[i].item.length; j++) {
        if (arr[i].item[j].edited) {
          arr[i].item[j].start_date = adjustDateFormat(arr[i].item[j].start_date);
          arr[i].item[j].end_date = adjustDateFormat(arr[i].item[j].end_date);
          arr[i].item[j].actual_start_date = adjustDateFormat(arr[i].item[j].actual_start_date);
          arr[i].item[j].actual_end_date = adjustDateFormat(arr[i].item[j].actual_end_date);
          arr[i].item[j].date_created = adjustDateFormat(arr[i].item[j].date_created);
          newItem.push(arr[i].item[j]);
        }
      }

      if (newItem.length > 0) {
        arr[i].item = newItem;
        newArr.push(arr[i]);
      }
    }

    if (newArr.length > 0) {
      saveWeekly(props.id, newArr).then((res) => {
        const mixpanelData = newArr.map(section => {
          const item = section.item?.[0] || {};

          return {
            work_item: item.work_item,
            psow_id: item.psow_id,
            sow_id: item.sow_id,
            start_date: item.start_date,
            end_date: item.end_date,
            actual_start_date: item.actual_start_date,
            actual_end_date: item.actual_end_date,
            project_id: props?.id,
            phase: section.phase,
            phase_id: section.phase_id,
            date_range: section.date_range,
            progress: section.progress
          };
        });
        if (res.data.status == 200) {
          mixpanelData.forEach((item) => {
            trackEvent(mixPanelEvents.SAVE_TWO_WEEKS, {
              'Source': 'Project - Reports - Two Weeks Ahead',
              ...item,
            })
          })
          Swal.fire({
            icon: 'success',
            title: 'Your work has been saved!',
            showConfirmButton: false,
            timer: 1500,
          });
          getTwoWeeks(date);
          setHasChanges(false);
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: res.data.message,
            showConfirmButton: false,
            timer: 2500,
          });
        }
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops..',
        text: 'No data to be save',
        confirmButtonColor: '#23303D',
      });
    }
  };

  const toggleShow = (value) => {
    const shownState = toggle.slice();
    const index = shownState.indexOf(value);

    if (index >= 0) {
      shownState.splice(index, 1);
      setToggle(shownState);
    } else {
      shownState.push(value);
      setToggle(shownState);
    }
  };

  const changestartdate = (value, Index, dataIndex, category) => {
    const newArr = [...weeklyReport];
    if (category === 'target') {
      newArr[dataIndex].item[Index].StartDate = value;
    } else if (category === 'actual') {
      newArr[dataIndex].item[Index].actual_start_date = value;
    }
    newArr[dataIndex].item[Index].edited = true;
    setWeeklyReport(newArr);
    setHasChanges(true);
  };

  const changeenddate = (value, Index, dataIndex, category) => {
    const newArr = [...weeklyReport];
    if (category === 'target') {
      newArr[dataIndex].item[Index].EndDate = value;
    } else if (category === 'actual') {
      newArr[dataIndex].item[Index].actual_end_date = value;
    }
    newArr[dataIndex].item[Index].edited = true;
    setWeeklyReport(newArr);
    setHasChanges(true);
  };

  const ItemBadge = ({ underBudget, delayed, incomplete }) => {
    let badge = [];

    if (underBudget == 1) {
      badge.push(
        <CBadge color="aimhi-success" className="badge-stats" style={{ marginTop: '15px', width: '150px' }} key="budget">
          WITHIN BUDGET
        </CBadge>,
      );
    } else {
      badge.push(
        <CBadge color="aimhi-danger" className="badge-stats" style={{ marginTop: '15px', width: '150px' }} key="budget">
          OVER BUDGET
        </CBadge>,
      );
    }

    if (incomplete == 1) {
      badge.push(
        <CBadge color="aimhi-success" className="badge-stats" style={{ marginTop: '15px', width: '150px' }} key="status">
          INCOMPLETE
        </CBadge>,
      );
    } else {
      if (delayed == 0) {
        badge.push(
          <CBadge color="aimhi-success" className="badge-stats" style={{ marginTop: '3px', width: '150px' }} key="status">
            ON-TIME
          </CBadge>,
        );
      } else {
        badge.push(
          <CBadge color="aimhi-danger" className="badge-stats" style={{ marginTop: '3px', width: '150px' }} key="status">
            DELAYED
          </CBadge>,
        );
      }
    }

    return badge;
  };

  const WeeklyCard = weeklyReport.map((data, index) => {
    let dataIndex = index;

    const collapseCard = data.item.map((item, innerIndex) => {
      let itemStatus = item.status;
      let colorstatus = '';

      if (itemStatus >= '100') {
        colorstatus = 'green';
      } else if (itemStatus >= '1' && itemStatus <= '99') {
        colorstatus = 'blue';
      } else if (itemStatus <= '0') {
        colorstatus = 'gray';
      }

      return (
        <CCard classNname="shadow report-card" style={{ marginBottom: 0, marginLeft: '40px' }} key={innerIndex}>
          <CCardBody style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 15 }}>
            <CRow>
              <div className="float-left left-design-report"></div>
              <CCol lg="4" style={{ padding: '10px' }}>
                <span className="report-label">{item.work_item}</span>
              </CCol>

              <CCol lg="1.5" style={{ padding: '10px' }} id="Status">
                <CCol style={{ textAlign: 'center' }}>
                  <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Status</span>
                </CCol>
                <div className="progress-dropdown">
                  <div className="progress-dropdown" style={{ marginTop: '3px' }}>
                    <div style={{ position: 'relative' }}>
                      <CProgress style={{ height: '15px', width: '6rem' }}>
                        <div
                          id="editable"
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            color: 'black',
                            fontWeight: 'bold',
                          }}
                        >
                          <span>{`${itemStatus}%`}</span>
                        </div>
                        <CProgressBar value={itemStatus} className={colorstatus + ' ' + 'select-design'} />
                      </CProgress>
                    </div>
                  </div>
                </div>
              </CCol>

              <CCol lg="4" className="text-center">
                <CRow>
                  <CCol className="text-center" id="Target/Actual Start">
                    <CRow style={{ paddingBottom: '10px' }}>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Target Start</span>
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <DatePicker
                          className="border-2 reports"
                          placeholderText="mm/dd/yyyy"
                          value={item.start_date}
                          disabled
                          onChange={(value) => {
                            changestartdate(value, innerIndex, dataIndex, 'target');
                          }}
                        />
                      </CCol>

                      <CCol xs="12" sm="12" md="12" lg="12">
                        <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Actual Start</span>
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <DatePicker
                          className="border-2 border-black reports"
                          placeholderText="mm/dd/yyyy"
                          selected={item.actual_start_date ? new Date(item.actual_start_date) : null}
                          value={item.actual_start_date}
                          isClearable
                          onChange={(value) => {
                            changestartdate(adjustDateFormat(value ? value.toLocaleDateString() : null), innerIndex, dataIndex, 'actual');
                          }}
                          disabled={!item.is_editable}
                        />
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol className="text-center" id="Target/Actual End">
                    <CRow style={{ paddingBottom: '10px' }}>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Target End</span>
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <DatePicker
                          className="border-2 reports"
                          placeholderText="mm/dd/yyyy"
                          value={item.end_date}
                          disabled
                          onChange={(value) => {
                            changestartdate(value, innerIndex, dataIndex, 'target');
                          }}
                        />
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Actual End</span>
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <DatePicker
                          className="border-2 border-black reports"
                          placeholderText="mm/dd/yyyy"
                          selected={item.actual_end_date ? new Date(item.actual_end_date) : null}
                          value={item.actual_end_date}
                          isClearable
                          onChange={(value) => {
                            changeenddate(adjustDateFormat(value ? value.toLocaleDateString() : null), innerIndex, dataIndex, 'actual');
                          }}
                          disabled={!item.is_editable}
                        />
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>

              <CCol lg="2" style={{ padding: '10px' }} id="Comment/s">
                <CCol>
                  <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Plans</span>
                </CCol>
                <CButton color="aimhi-textlight-neutral" size="sm" block onClick={() => openModalComment(item)}>
                  View
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      );
    });

    return (
      <CCol key={index} style={{ marginTop: '20px' }}>
        <CCard style={{ marginBottom: 0 }} className="shadow" onClick={() => toggleShow(data.phase_id)}>
          <CCardBody>
            <CRow>
              <CCol lg="4">
                <span className="float-left circle-number">
                  <span>{index + 1}</span>
                </span>
                <div className="report-sow-label">{data.phase}</div>
              </CCol>

              <CCol lg="2" className="align-center" style={{ marginLeft: '30px' }}>
                <div className="circular-progress-size">
                  <CircularProgressbarWithChildren
                    className="circular-progress-size"
                    value={data.progress.toFixed(2)}
                    text={`${data.progress.toFixed(2)}%`}
                    styles={{
                      path: {
                        stroke: '#351D75',
                        strokeLinecap: 'butt',
                        transition: 'stroke-dashoffset 0.5s ease 0s',
                        transformOrigin: 'center center',
                        circleRatio: '0',
                        strokeWidth: '-10',
                      },
                      trail: {
                        stroke: '#9c9c9c',
                        strokeLinecap: 'butt',
                        transform: 'rotate(0.25turn)',
                        transformOrigin: 'center center',
                        circleRatio: '0',
                        strokeWidth: '-10',
                      },
                      text: {
                        fill: '#23303D',
                        fontSize: '20px',
                        fontWeight: '700',
                      },
                      background: {
                        fill: '#54c2a2',
                      },
                    }}
                  />
                </div>
                <span className="status-label align-text-mobile">Progress</span>
              </CCol>

              <CCol lg="4" xl="2">
                <ItemBadge underBudget={data.under_budget} delayed={data.delayed} incomplete={data.incomplete} />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
        <CCol xl="12" style={{ padding: 0 }}>
          <div className={`transition-all duration-300 ${toggle.includes(data.phase_id) ? 'opacity-100' : 'max-h-0 overflow-hidden opacity-0'}`}>
            {toggle.includes(data.phase_id) && collapseCard}
          </div>
        </CCol>
      </CCol>
    );
  });

  const option = weeks.map((data, Index) => {
    return (
      <option key={Index} value={`${data.start_date} - ${data.end_date}`}>
        {data.start_date} - {data.end_date}
      </option>
    );
  });

  const handleDownload = async (project_id, type) => {
    setIsLoading(true);
    const { balance, status } = await refreshSubscription();
    const [start_date, end_date] = date.split(' - ').map((d) => d.trim());

    const proceedDownload = async () => {
      trackEvent(mixPanelEvents.DOWNLOAD_TWO_WEEKS, {
        'Source': 'Project - Reports - Two Weeks',
      });
      try {
        DownloadReportWeekly(project_id, start_date, end_date, type);
        closeDialog();
      } catch (error) {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        Swal.fire({
          title: 'Oopss',
          icon: 'error',
          text: 'Something went wrong. Please try again',
        });
      } finally {
        setIsLoading(false);
      }
    };

    if (status === 0) {
      if (balance != null && +balance < 15) return (setIsLoading(false), NoCreditsLeft());
      openDialog({
        title: 'Power Tool Feature',
        message: `You have ${balance} credits. Get unlimited Power Tools for P250/month or pay P15 per use. Once you use your credits, there's no going back—no refunds or changes. Are you sure you want to continue? If so, how would you like to proceed?`,
        onPrimaryAction: () => proceedDownload(),
        primaryActionText: 'Pay P15',
        onSecondaryAction: () => handleSubscriptionRequest().then((res) => res === 1 && proceedDownload()).finally(() => setIsLoading(false)),
        secondaryActionText: 'Subscribe for P250',
        iconType: 'info',
        iconColor: '#3B74BE',
        onClose: () => setIsLoading(false),
      });
    } else {
      proceedDownload();
    }
  };

  return (
    <>
      <CCol style={{ marginTop: '20px' }}>
        <CRow>
          <CCol xl="6">
            <CFormGroup row>
              <CLabel>Date Range</CLabel>
              <CCol xl="9">
                <CSelect onChange={(e) => getTwoWeeks(e.target.value)} value={date}>
                  {option}
                </CSelect>
              </CCol>
            </CFormGroup>
          </CCol>
          <CCol xl="2"></CCol>
          <CCol xl="2">
            {isDownloadableReportAllowed && (
              <CButton
                color="aimhi-textlight-neutral"
                variant="outline"
                size="sm"
                block
                onClick={() => {
                  handleDownload(projectId, 2);
                }}
              >
                {isLoading ? (
                  <>
                    <CSpinner color="#23303D" size="sm" />
                    <span style={{ marginLeft: '8px' }}>Download</span>
                  </>
                ) : (
                  'Download'
                )}
              </CButton>
            )}
          </CCol>

          <CCol xl="2">
            <CButton color="aimhi-textlight-neutral" size="sm" block onClick={saveChanges} disabled={!hasChanges}>
              Save changes
            </CButton>
          </CCol>
        </CRow>
        {WeeklyCard}
      </CCol>
      {isModalCommentOpen && (
        <ModalComments
          isModalOpen={isModalCommentOpen}
          title="Plans"
          reportData={reportData}
          onClose={closeModalComment}
          date={date}
          type={3}
        />
      )}
    </>
  );
};

export default TwoWeeks;
